import {
  CcfAccordion,
  CcfAccordionDetails,
  CcfAccordionSummary,
  CcfBox,
  CcfButton,
  CcfDoubleArrowIcon,
  CcfTypography,
  CcfUpArrowIcon,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { useMediaQuery, useTheme, Box } from '@mui/material';
import SchedulerLargeView from '../../../ccf-app-schedule/ccf-schedular-large-view';
import ccfAppSchedulerStyles from '../../../ccf-app-schedule/ccf-app-schedule.styles';
import { useState } from 'react';

/* eslint-disable-next-line */
export interface CcfWemMyScheduleProps {}

/**
 * CcfWemMySchedule - used to display wem my schedule
 * @param props - CcfWemMySchedule
 * @example `<CcfWemMySchedule />`
 */
export function CcfWemMySchedule(props: CcfWemMyScheduleProps) {
  const theme = useTheme();
  const isSmView = useMediaQuery(theme.breakpoints.down('xl'));
  const schedulerStyles = ccfAppSchedulerStyles(theme, isSmView);
  const [expanded, setExpanded] = useState('');
  /**
   * handleChange Event - used to expand and collapse of address accordion
   * @param panel- 'address'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - handleChange(panel)
   */
  const handleChange = (panel: string) => {
    setExpanded(expanded === 'oncall' ? '' : panel);
  };
  /**
   * handleChange Event - used to expand and collapse of address accordion
   * @param panel- 'address'
   * @param event - changeevent
   * @param newExpanded - boolean
   * @example - handleChange(panel)
   */
  const handleChangeOutOfOffice = (panel: string) => {
    setExpanded(expanded === 'outofoffice' ? '' : panel);
  };
  return (
    <CcfBox className={styles.wemScheduleContainer}>
      <CcfBox>
        <CcfTypography className={styles.wemTabTitle} translationKey={'mySchedule'}>
        </CcfTypography>
      </CcfBox>
      <CcfBox className={styles.scheduleSection}>
        <Box className={styles.w75}>
          <SchedulerLargeView isWemView={true} />
        </Box>
        <CcfBox className={styles.wemScheduleDetails}>
          <CcfBox className={styles.agendaBlock}>
            <CcfTypography className={styles.agendaTxt} translationKey={'agenda'}></CcfTypography>
          </CcfBox>
          <CcfTypography className={styles.noScheduleTxt} translationKey={'noSchedule'}>
            
          </CcfTypography>
          <CcfBox className={styles.accordionSection}>
            {' '}
            <CcfAccordion
              square
              expanded={expanded === 'oncall'}
              onChange={() => handleChange('oncall')}
              sx={schedulerStyles.accordionWemContainer}
            >
              <CcfAccordionSummary
                expandIcon={
                  <CcfDoubleArrowIcon sx={schedulerStyles.expandedIcon} />
                }
                aria-controls="contact-history-header"
                sx={
                  expanded === 'oncall'
                    ? schedulerStyles.ccfWemAccordionHeader
                    : schedulerStyles.accordionWemHeaderExpand
                }
              >
                <CcfTypography translationKey={'onCall'}></CcfTypography>
              </CcfAccordionSummary>
              <CcfAccordionDetails sx={schedulerStyles.ccfWemAccordionDetails}>
                <CcfTypography translationKey={'noData'}></CcfTypography>
              </CcfAccordionDetails>
            </CcfAccordion>
            <CcfAccordion
              square
              expanded={expanded === 'outofoffice'}
              onChange={() => handleChangeOutOfOffice('outofoffice')}
              sx={schedulerStyles.accordionWemContainer}
            >
              <CcfAccordionSummary
                expandIcon={
                  <CcfDoubleArrowIcon sx={schedulerStyles.expandedIcon} />
                }
                aria-controls="contact-history-header"
                sx={
                  expanded === 'outofoffice'
                    ? schedulerStyles.ccfWemAccordionHeader
                    : schedulerStyles.accordionWemHeaderExpand
                }
              >
                <CcfTypography translationKey={'outofoffice'}></CcfTypography>
              </CcfAccordionSummary>
              <CcfAccordionDetails sx={schedulerStyles.ccfWemAccordionDetails}>
                <CcfTypography translationKey={'noData'}></CcfTypography>
              </CcfAccordionDetails>
            </CcfAccordion>
          </CcfBox>
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}
